import React from 'react';
import styled from 'styled-components';
import { Row, Column } from 'react-foundation';
import { YesNoSwitch } from './YesNoSwitch';
// import { formatMsisdn } from '../utils/helpers';

const StyledRow = styled(Row)``;

StyledRow.defaultProps = {};

const TitleColumn = styled(Column)`
	font-size: 1.25rem;
	line-height: 1.3;
	padding-top: 5px;
	font-weight: 300;
`;

TitleColumn.defaultProps = {
	small: 6,
	medium: 8,
	large: 9
};

interface TitleRowProps {
	title: string;
	children: React.ReactNode;
}

const TitleRow: React.FC<TitleRowProps> = (props: TitleRowProps) => {
	const { title, children } = props;
	return (
		<StyledRow>
			<TitleColumn>{title}</TitleColumn>
			{React.Children.toArray(children)}
		</StyledRow>
	);
};

const Wrapper = styled.div`
	& + & {
		margin-top: 1rem;
	}
`;

const Description = styled.div`
	margin-top: 1rem;
`;

const OptionWrapper = styled(Column)`
	text-align: right;
`;

const InfoWrapper = styled.div`
	margin-top: 1rem;
`;

OptionWrapper.defaultProps = {
	small: 6,
	medium: 4,
	large: 3
};

const makeSettingRow = (OptionElement: any) => {
	const SettingRow = (props: any) => {
		const { title, updating, infoText, voicemailMsisdn, ...otherProps } = props;
		const children = React.Children.toArray(props.children);

		return (
			<Wrapper>
				<TitleRow title={title}>
					<OptionWrapper>
						<OptionElement {...otherProps} />
					</OptionWrapper>
				</TitleRow>
				{/*TODO: Voicemail number hidden until related backend problem is fixed*/}
				{/*{voicemailMsisdn && (*/}
				{/*	<React.Fragment>*/}
				{/*		<b>Vastaajanumero</b> {formatMsisdn(voicemailMsisdn)}*/}
				{/*	</React.Fragment>*/}
				{/*)}*/}
				{updating && <InfoWrapper>{infoText}</InfoWrapper>}
				{children.length > 0 && <Description>{children}</Description>}
			</Wrapper>
		);
	};
	return SettingRow;
};

const StyledSelect = styled.select`
	width: auto;
`;

interface Option {
	id: string | number;
	value: string;
}

interface DropdownProps {
	options: Option[];
	selected: string | number;
	onChange: (value: string) => void;
	disabled: boolean;
}

const DropdownImpl: React.FC<DropdownProps> = (props: DropdownProps) => {
	const { options, selected, onChange, disabled } = props;
	return (
		<StyledSelect disabled={disabled} value={selected} onChange={(e) => !disabled && onChange(e.target.value)}>
			{options.map(({ id, value }) => (
				<option key={id} value={id}>
					{value}
				</option>
			))}
		</StyledSelect>
	);
};

export const Dropdown = makeSettingRow(DropdownImpl);

const TextColumn = styled(Column)`
	font-size: 1.25rem;
	font-weight: 300;
`;

TextColumn.defaultProps = {
	small: 12
};

interface TextRowProps {
	children: React.ReactNode;
}

export const TextRow: React.FC<TextRowProps> = (props: TextRowProps) => {
	const { children } = props;
	return (
		<StyledRow>
			<TextColumn>{React.Children.toArray(children)}</TextColumn>
		</StyledRow>
	);
};

export const Switch = makeSettingRow(YesNoSwitch);
